import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms'; // 👈 Importa FormsModule
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { CustomDateFilterComponent } from '../custom-date-filter/custom-date-filter.component';
import { CustomDateRangeFilterComponent } from '../custom-date-range-filter/custom-date-range-filter.component';
import { CustomDateTimeRangeFilterComponent } from '../custom-date-time-range-filter/custom-date-time-range-filter.component';
import { CustomNumberFilterComponent } from '../custom-number-filter/custom-number-filter.component';
import { CustomNumberRangeFilterComponent } from '../custom-number-range-filter/custom-number-range-filter.component';
import { CustomSelectFilterComponent } from '../custom-select-filter/custom-select-filter.component';
import { CustomTextFilterComponent } from '../custom-text-filter/custom-text-filter.component';

@Component({
  selector: 'app-custom-filters',
  imports: [TableModule, NgIf, SelectModule, FormsModule, CustomTextFilterComponent,
    CustomSelectFilterComponent, CustomNumberRangeFilterComponent, CustomNumberFilterComponent,
    CustomDateRangeFilterComponent, CustomDateTimeRangeFilterComponent, CustomDateFilterComponent],
  standalone: true,
  templateUrl: './custom-filters.component.html',
  styleUrls: ['./custom-filters.component.scss'],
})
export class CustomFiltersComponent {
  @Input() field!: string;
  @Input() inputType!: string;
  @Input() placeholder!: string;
  @Input() itemsSelect: { label: string; value: any }[] = [];
  @Input() resetTrigger: string = '';
  @Input() control!: FormControl;
  @Input() controlAlter!: FormControl;
  @Output() onChangeFilter = new EventEmitter<{ propertyName: string, valueFilter: any }>();

  minValue = signal<number>(1);
  maxValue = signal<number | null>(null);
  rangeDates = signal<Date[]>([]);

  updateMaxValue() {
    if (this.maxValue() !== null && this.maxValue()! < this.minValue()) {
      this.maxValue.set(this.minValue());
    }
  }

  onFilter(event: any) {
    this.onChangeFilter.emit(event);
  }
}
